module.exports = __webpack_public_path__ + "static/img/a.83bdeac4.gif";